import { render, staticRenderFns } from "./InventoryOff.vue?vue&type=template&id=171813f4&scoped=true&"
import script from "./InventoryOff.vue?vue&type=script&lang=js&"
export * from "./InventoryOff.vue?vue&type=script&lang=js&"
import style0 from "./InventoryOff.vue?vue&type=style&index=0&id=171813f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171813f4",
  null
  
)

export default component.exports